export default __webpack_public_path__ + "static/media/logo.e02c8292.svg";